/* @ngInject */
const myWagonDisplayDispositions = () => {
  return {
    restrict: 'E',
    scope: {
      myDispositions: '=',
    },
    template: require('./myWagonDisplayDispositions.html'),
    /* @ngInject */
    controller: ($scope) => {

    },
    link: {
      pre: (scope, element, attrs) => { },
      post: (scope, element, attrs, ctrl) => { },
    },
  }
}
export default myWagonDisplayDispositions



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/wagon/directives/display/myWagonDisplayDispositions.js